import * as React from 'react'
import { Flex } from 'components/primitives'
import { StyleProps } from 'types/global'

function List({ style, children }: StyleProps & { children: React.ReactNode }) {
  return <Flex style={{ flexDirection: 'column', ...style }}>{children}</Flex>
}

export default List
